/**
 * Money is integer cents everywhere. These helpers exist so no part of the
 * codebase is tempted to reach for a float.
 */

export function formatCents(cents: number): string {
  const sign = cents < 0 ? '-' : '';
  const abs = Math.abs(cents);
  // Grouped, because these are read by a person deciding whether a budget is
  // $50,000 or $5,000 and `$500000.00` is exactly the string that gets that
  // wrong. Division by 100 is safe here: the value is an integer number of
  // cents, and only the DISPLAY leaves the integer domain.
  return `${sign}$${(abs / 100).toLocaleString('en-US', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })}`;
}

/**
 * Earnings for a CPM campaign: views / 1000 * rate, floored to whole cents.
 * Floor (not round) so the ledger can never pay out more than was reserved.
 */
export function cpmEarningCents(views: number, ratePerThousandCents: number): number {
  if (views <= 0 || ratePerThousandCents <= 0) return 0;
  return Math.floor((views * ratePerThousandCents) / 1000);
}
